export default "__VITE_ASSET__BlO0KJV4__"